import BecomeMemberModal from './BecomeMemberModal';

export default BecomeMemberModal;
